import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface State {
  countryStateData: any;
  countryGridData: any;
  isLoading: boolean;
  error?: string;
  legendValues: null;
  aggregated: any;
  gridLatLng: any;
  selectedGeometry: any;
}

const initialState: State = {
  isLoading: false,
  countryStateData: null,
  countryGridData: null,
  legendValues: null,
  aggregated: null,
  gridLatLng: null,
  selectedGeometry: null,
};

const countryApiSlice = createSlice({
  name: "country",
  initialState,
  reducers: {
    startLoading(state: State) {
      state.isLoading = true;
    },
    stopLoading(state: State) {
      state.isLoading = false;
    },
    hasError(state: State, action: PayloadAction<string>) {
      state.isLoading = false;
      state.error = action.payload;
    },
    handleCountryStateDetails(state: State, action: PayloadAction<any>) {
      state.isLoading = false;
      state.countryStateData = action.payload?.data;
      state.legendValues = action.payload?.min_max_values;
      state.aggregated = action.payload?.aggregated;
    },
    handleCountryGridDetails(state: State, action: PayloadAction<any>) {
      state.isLoading = false;
      state.countryGridData = action.payload?.data;
      state.legendValues = action.payload?.min_max_values;
      state.aggregated = action.payload?.aggregated;
    },
    handleCountryGridLatLng(state: State, action: PayloadAction<any>) {
      state.gridLatLng =
        action.payload && action.payload?.features[0]
          ? action.payload?.features[0]
          : null;
      state.selectedGeometry =
        action.payload?.features[0]?.geometry?.coordinates[0][0] || null;
    },
  },
});

export const {
  startLoading,
  stopLoading,
  hasError,
  handleCountryStateDetails,
  handleCountryGridDetails,
  handleCountryGridLatLng,
} = countryApiSlice.actions;

export default countryApiSlice.reducer;
